import { Box } from '@factorialco/deprecated-design-system'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import SingleChoice from 'modules/core/components/Filter/filters/SingleChoice'
import i18n from 'modules/core/lib/i18n'

type ReviewerStrategyOption = {
  label: string
  value: PerformanceReviewerStrategiesStrategyEnum
}

const orderedStrategies: PerformanceReviewerStrategiesStrategyEnum[] = [
  'manager',
  'self',
  'direct_reports',
  'peers',
]

export const buildReviewerStrategyOptions = (
  strategies: PerformanceReviewerStrategiesStrategyEnum[]
): ReviewerStrategyOption[] => {
  const labelByStrategy: Record<PerformanceReviewerStrategiesStrategyEnum, string> = {
    manager: i18n.t('performance_process.reviews.answer_evaluation.evaluation_type.manager.title'),
    self: i18n.t('performance_process.reviews.answer_evaluation.evaluation_type.self.title'),
    direct_reports: i18n.t(
      'performance_process.reviews.answer_evaluation.evaluation_type.direct_reports.title'
    ),
    peers: i18n.t('performance_process.reviews.answer_evaluation.evaluation_type.peers.title'),
  }

  return orderedStrategies
    .filter((strategy) => strategies.includes(strategy))
    .map((strategy) => ({ label: labelByStrategy[strategy], value: strategy }))
}

export const ReviewerStrategyFilter: React.FC<{
  value: PerformanceReviewerStrategiesStrategyEnum
  options: ReviewerStrategyOption[]
  onChange: (value: PerformanceReviewerStrategiesStrategyEnum) => void
}> = ({ value, options, onChange }) => {
  return (
    <Box width="fit-content">
      <SingleChoice
        noFooter
        value={value}
        label={i18n.t('performance_process.reviews.filter_by')}
        options={options}
        onValueChange={onChange}
      />
    </Box>
  )
}
